import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { pillarHref, pillars } from '../../data/pillars';
import { fadeUp } from '../../utils/motion';

/** Full list of NCJI's five pillars: what is assessed. */
export function PillarList() {
  return <motion.ol {...fadeUp} aria-label="NCJI's five pillars" className="border-t border-line" data-id="element-1640" data-mp="3x2yy811x9q3">
      {pillars.map(pillar => <li key={pillar.id} className="border-b border-line" data-id="element-1641" data-mp="iko3m6dkrh04">
          <a href={pillarHref(pillar.id)} className="group grid grid-cols-[2.5rem_1fr_auto] gap-4 py-7 rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal" data-id="element-1642" data-mp="dmmhfckur1kf">
            <span className="font-heading font-bold text-teal pt-1" data-id="element-1643" data-mp="mnu4szltyhzq">{pillar.order}</span>
            <span className="grid grid-cols-1 lg:grid-cols-12 gap-3 lg:gap-10" data-id="element-1644" data-mp="2tejve62xnqws">
              <span className="lg:col-span-5 font-heading font-bold text-xl text-ink-dark leading-snug group-hover:text-navy transition-colors duration-150" data-id="element-1645" data-mp="2ofgxd5ldekyb">
                {pillar.name}
              </span>
              <span className="lg:col-span-7" data-id="element-1646" data-mp="d1gdgh2xz7of">
                <span className="block text-lg text-ink-muted leading-relaxed" data-id="element-1647" data-mp="cy2b38ua2ygz">{pillar.description}</span>
                <span className="mt-3 block text-ink-dark italic" data-id="element-1648" data-mp="mq850o43bpyt">“{pillar.guidingQuestion}”</span>
              </span>
            </span>
            <ArrowRight size={18} aria-hidden="true" className="mt-1.5 text-teal transition-transform duration-150 ease-out group-hover:translate-x-1" data-id="element-1649" data-mp="qqs0ln90mliu" />
          </a>
        </li>)}
    </motion.ol>;
}